// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.
//
// A non-white-space area of the building shell (MMR, admin, loading, …).
// Purely presentational: geometry and tone in, SVG out.

import React from 'react';
import type { PlanRoom } from '../../../types/floorPlan';

/** Rooms are too small for wrapped text; the label is dropped when it can't fit. */
const MIN_LABEL_W = 30;
const MIN_LABEL_H = 18;

export default function PlanRoomShape({ room }: { room: PlanRoom }) {
  const showLabel = room.w >= MIN_LABEL_W && room.h >= MIN_LABEL_H;
  return (
    <g className={`plan-room plan-room-${room.tone}`} data-testid={`plan-room-${room.id}`}>
      <rect x={room.x} y={room.y} width={room.w} height={room.h} className="plan-room-fill" />
      {showLabel && (
        <text
          x={room.x + room.w / 2}
          y={room.y + room.h / 2}
          className="plan-room-label"
          textAnchor="middle"
          dominantBaseline="middle"
        >
          {room.label.toUpperCase()}
        </text>
      )}
    </g>
  );
}
